import { Injectable } from '@angular/core';
import { AlertService } from './notification-alert/alert.service';
import { LoaderService } from './loader/loader.service';
import * as _ from 'underscore';
import { environment } from 'environments/environment';

export const config = {

  HOST: environment.apiUrl,
  SOCKET_HOST: environment.apiUrl,
  PORT: environment.port,
  PROTOCOL: environment.protocol,
  PREFIX: 'canstring',

  DOMAIN_NAME: 'www.canstringbot.com',
  // DOMAIN_NAME: 'demo.canstrings.com',
  VERSION: 'v1',
  DEFAULT_RECORD_LIMIT: 1000,
  DEFAULT_OFFSET: 0,
  DEFAULT_SCROLL_DIST: 2,
  SCROLL_THROTTLE: 300,
  PROFILE_SIZE: 1024, // 1 GB
  PROFILE_EXT: 'PNG,JPEG,JPG',
  POST_FILE_EXT: 'PNG,JPEG,JPG,MP4',
  TOPIC_EXT: 'PNG,JPEG,JPG,SVG,MP3,MP4,WAV,PDF,PPT,PPTX,PPTM,XML,XLS,XLSX,XLSM,XLW,DOC,DOCX,TXT',
  TOPIC_FILE_SIZE: 1024, // 1 GB
  ATTACHMENT_SIZE: 1024, // 1 GB
  ATTACHMENT_EXT: 'PNG,JPEG,JPG,SVG,MP3,MP4,WAV,AVI,FLV,JS,PDF,CSV,PPT,PPTX,PPTM,XML,PSD,XLS,XLSX,XLSM,XLW,SQL,JAR,CSS,HTML,HTM,PHP,ZIP,RAR,DOC,DOCX,TXT,DAT,RPTDESIGN,JSON',
  ATTACHMENT_LIMIT: 5,
  ASSIGN_FILE_EXT: 'PNG,JPEG,JPG,SVG,PDF,PPT,PPTX,PPTM,DOC,DOCX',
  ASSIGN_FILE_SIZE: 1024, // 1GB
  NOTIFICATION_TIMEOUT: 5000,
  MAX_ATTACH_FILE_SIZE: 1024, //1 GB
  ENCRYPTION: true,
  SECRETKEY: 'WIiOiIxMjM0NTY3ODkwIiwibmFtZ',
  TIMINIG: 10000,
  copyrights: new Date().getFullYear(),
  fileSupportFormat: 'png, jpeg, jpg, svg, mp3, mp4, wav, pdf, ppt, pptx, pptm, xml, xls, xlsx, xlw, doc, docx, txt'
};


///company/profile/:file_id

export const path = {
  PROFILE_URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}/users/profile/`,
  PRE_PROFILE_URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}/users/preProfile/`,
  NEW_PROFILE_URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}/users/readfile`,
  COMPANY_URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}/company/profile/`
};



export const BASE_DOMAIN_URI = `${config.PROTOCOL}://${config.HOST}`;

//LLM Train data Restful API
export const AI_BOT_CONFIG = {
  agent: {
    llmUrl: `${BASE_DOMAIN_URI}`+'/generic_llm/',
    socketUrl: `${BASE_DOMAIN_URI}`
  },
  training: {
    model1Url: `${BASE_DOMAIN_URI}`, //Bharathi Model
    model2Url: `${BASE_DOMAIN_URI}`, //Dev Model
    model3Url: `${BASE_DOMAIN_URI}`,
    model4Url: `${BASE_DOMAIN_URI}` + '/benefits-chat', //Meet Patel Model
    model5Url: `${BASE_DOMAIN_URI}` + '/email_analytics' // Dev Model email analytics
  }
};

export const BASE_URI = {
  URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}`
};

export const UPLOAD_URI = {
  URL: `${config.PROTOCOL}://${config.HOST}:${config.PORT}/${config.PREFIX}/${config.VERSION}/users/fileUploadProgress`
};

export const AUTH_TOKEN = {
  TOKEN: localStorage.getItem('token')
};

export const COMPANY_ID = {
  Company_id: localStorage.getItem('company_id')
};

export const MENU_ICON = {
  dashboard: 'pi-gauge',
  documentnew: 'pi-file',
  maps: 'pi-map-marker',
  company: 'pi-building',
  aiassist: 'fa-robot',
  policy_library: 'fa-envelope-open-tex',
  chats: 'pi-comments',
  channels: 'pi-bell',
  // bulletineBoard: 'fa-thumb-tack',
  user_and_group: 'pi-users',
  settings: 'pi-cog',
  elibraryandcourse: 'pi-folder',
  attendance: 'fa-calendar-times-o',
  chatbot: 'fa-weixin',
  home_work: 'fa-thumb-tack',
  staff_room: 'fa-users-rectangle',
  study_room: 'pi-book',
  video_quiz: 'pi-video',
  feedback: 'pi-slack',
  subscription: 'fa-money-bill',
  summarization: 'pi-file-o',
  team_chat: 'fa-people-group',
  excelqanda: 'pi-file-excel',
  manageclient: 'pi-users',
  askquestions: 'pi-question-circle',
  talkai: 'assets/images/ai-agentic/agentic_ai.png',
};


export const LLm_url = {
  Base_url: `${AI_BOT_CONFIG.training.model2Url}/absenceassistance-library/`,
  Disclaimer: "<b>Disclaimer:</b> <span>The information provided from this tool is not for legal advice, and is intended to provide references in regards to Absence.</span>"
}

export interface ResolveEmit {
  resolved?: boolean;
  closedWithOutResolving?: string;
};


@Injectable({
  providedIn: 'root'
})
export class AlertPopup {

  constructor(
    private alertService: AlertService,
    private loaderService: LoaderService
  ) { }

  // Success notification
  showAlertMessage(response: any): void {

    const message = this.getMessage(response);

    if (message) {
      this.alertService.success(message);
    }

  }

  // Error notification
  showErrorMessage(error: any): void {

    const message = this.getMessage(error);

    this.alertService.error(
      message || 'Something went wrong. Please try again.'
    );

  }

  // Warning notification
  showWarningMessage(message: string): void {

    if (message?.trim()) {
      this.alertService.warn(message);
    }

  }

  // Information notification
  showInfoMessage(message: string): void {

    if (message?.trim()) {
      this.alertService.info(message);
    }

  }

  // Extract message from API response
  private getMessage(response: any): string {

    if (!response) {
      return '';
    }

    if (typeof response === 'string') {
      return response.trim();
    }

    if (typeof response === 'object') {

      const message =
        response?.message ||
        response?.error?.message ||
        response?.error ||
        response?.data?.message;

      if (typeof message === 'string') {
        return message.trim();
      }

    }

    return '';
  }
}

@Injectable({
  providedIn: 'root'
})
export class HttpLoader {

  constructor(
    private loaderService: LoaderService
  ) { }

  public showLoader(): void {
    this.loaderService.showLoader();
  }

  public hideLoader(): void {
    this.loaderService.hideLoader();
  }
}
